import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Input, Alert } from "antd";
import { ClassicButton } from "../../../common/ButtonWithLoading";
import { phonenumberValid } from "../../../../helpers/Utils";
import {
  createServiceRepairSms,
  fetch_sms_services,
} from "../../../../redux/Actions/Service/serviceAction";
import { SelectForm } from "../../../common/Buttons";
import { buildCountriesArray } from "../../../../helpers/OrdersFunctionsGlobal";
import useFetch from "../../../../hooks/useFetch";
import ListSmsSendings from "../../../table/ListSmsSendings";

const { TextArea } = Input;

function SmsSending({ id, phoneNumber, sms, country_id }) {
  const [countryId, setCountryId] = useState(country_id || undefined);
  useEffect(() => {
    setCountryId(country_id);
  }, [country_id]);
  const { value } = useFetch("/api/v1/countries");
  const countries = buildCountriesArray(value?.data);
  const { sms_template } = useSelector((state) => state.service);

  const [bodyText, setBodyText] = useState("");
  const [loading, setLoading] = useState(false);
  const [bodyTextID, setBodyTextID] = useState(undefined);
  const [alertText, setAlertText] = useState({
    success: "success",
    text: "",
    show: false,
  });
  const [error, setError] = useState(false);

  const dispatch = useDispatch();

  const sendSms = () => {
    if (bodyText.trim() === "") {
      return setError(true);
    }
    setLoading(true);
    const variables = {
      body: bodyText,
      phone: phoneNumber,
      id,
    };
    dispatch(createServiceRepairSms(id, variables)).then((res) => {
      if (res !== false) {
        setLoading(false);
        setAlertText({
          success: "info",
          text: "SMS sending.",
          show: true,
        });
        setBodyText("");
        setBodyTextID(undefined);
        setError(false);
        console.log("asd");
        setTimeout(() => {
          dispatch(fetch_sms_services(id)).then((res) => {
            console.log({ res });
            if (res.success) {
              setAlertText({
                success: "success",
                text: "SMS sended successfully.",
                show: true,
              });
            }
          });
        }, 1200);
      } else {
        setError(true);
        setLoading(false);
        setAlertText({
          success: "error",
          text: "Error occurred.",
          show: true,
        });
      }
    });
  };

  const setSmsText = (evt, arg) => {
    let value = evt;

    setBodyTextID(arg.children);
    setBodyText(value);
  };
  const smsOptions = sms_template.map((e) => ({
    label: e.message,
    value: e.body,
    country_id: e.country_id,
  }));
  return (
    <div className="col-12 bg-silver pt-3">
      {alertText.show && (
        <Alert
          className="mt-2"
          message={alertText.text}
          type={alertText.success}
          showIcon
        />
      )}
      <div className="pt-2 mb-2">
        <SelectForm
          onlyPlaceholder="Country"
          options={countries}
          onChange={(value) => {
            setCountryId(value);
            setBodyText("");
            setBodyTextID(undefined);
          }}
          value={countryId}
        />
      </div>
      <div className="mb-2">
        <SelectForm
          countryId
          onlyPlaceholder="Templates"
          options={smsOptions.filter((e) => e.country_id == countryId)}
          onChange={(evt, arg) => setSmsText(evt, arg)}
          value={bodyTextID}
        />
      </div>
      <div>
        <div style={{ width: "100%" }}>
          <TextArea
            placeholder="Text"
            value={bodyText}
            autoSize={{ minRows: 2, maxRows: 6 }}
            onChange={(e) => setBodyText(e.target.value)}
          />
        </div>
        <div
          style={{
            width: "100%",
            marginTop: "5px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="text-danger">{error && "Enter the text"}</div>

          {phonenumberValid(phoneNumber) && (
            <ClassicButton loading={loading} text="Send" onClick={sendSms} />
          )}
        </div>
      </div>
      <table className="table table-hover mt-3">
        <ListSmsSendings sms_sendings={sms} />
      </table>
    </div>
  );
}

export default SmsSending;
